<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<idt-common-styles-render
  *ngIf="piece"
  [styles]="piece.settings?.styles">

  <div
    *ngIf="product$ | async as product"
    class="single-product">
    <ng-container *ngIf="this.renderByDevice.isMobile && this.hasExtraImageEnabled; else simpleImg">
      <ng-container *ngIf="getBothImages(product); let imageData">
        <swiper
          *ngIf="piece?.settings?.general"
          [config]="config"
          >
          <ng-template
          *ngFor="let image of imageData; trackBy: trackByIdx"
          swiperSlide
          >
            <render-link
              [lang]="lang"
              [link]="getProductLink(product, image.imageDetail)"
              [piece]="piece"
              (renderLinkEvent)="onProductClick(product, image.imageDetail)">
              <img
              [lazySrc]="image.imageData"
              alt=""
              [attr.alt]="product.longDescription || product.name"
              (mouseenter)="onMainEnter()"
              (mouseleave)="onMainLeave()"/>
            </render-link>
        </ng-template>
        </swiper>
      </ng-container>
    </ng-container>
    <ng-template #simpleImg>
      <render-link
        [lang]="lang"
        [link]="getProductLink(product)"
        [piece]="piece"
        (renderLinkEvent)="onProductClick(product)">
        <img
        *ngIf="getProductImageData(product); let imageData"
        [lazySrc]="imageData"
        alt=""
        [attr.alt]="product.longDescription || product.name"
        (mouseenter)="onMainEnter()"
        (mouseleave)="onMainLeave()"/>
    </render-link>
    </ng-template>
    <render-link
      [lang]="lang"
      [link]="getProductLink(product)"
      [piece]="piece"
      (renderLinkEvent)="onProductClick(product)">
      <div class="product-data">
        <div
          *ngIf="hasToDisplayProductName && product.name"
          class="product-name">
          <render-wysiwyg
            class="product-name"
            [html]="getProductName(product.name)"
            [country]="country"
            [lang]="lang"
            [piece]="piece">
          </render-wysiwyg>
        </div>
        <div
          *ngIf="hasToDisplayProductDescription && product.longDescription"
          class="product-description">
          <render-wysiwyg
            [html]="getProductDescription(product.longDescription)"
            [country]="country"
            [lang]="lang"
            [piece]="piece">
          </render-wysiwyg>
        </div>
        <div
          *ngIf="hasToDisplayPrices"
          class="product-price-container">
            <render-product-prices
              [product]="product"
              [piece]="piece">
            </render-product-prices>
        </div>
    </div>
  </render-link>

  <render-product-purchase-options
    *ngIf="hasToDisplayProductCart"
    class="product-sizes"
    [product]="product"
    [imageDetails]="imageDetails"
    [country]="country"
    [lang]="lang"
    [piece]="piece">
  </render-product-purchase-options>

  <div
  *ngIf="piece?.settings?.general?.productVariants?.length"
  class="variants"
  [ngClass]="{'mobile-variant': renderByDevice.isMobile}"
  >
  <ng-container *ngFor="let variant of piece.settings!.general.productVariants;trackBy: trackByIdx">
    <render-link
      [lang]="lang"
      [link]="getProductLink(product, variant)"
      [piece]="piece"
      (renderLinkEvent)="onProductClick(product, variant)">
      <img
      *ngIf="getProductImageData(product, variant, 48); let imageData"
      [lazySrc]="imageData"
      alt=""
      [attr.alt]="product.longDescription || product.name"
      (mouseenter)="onDetailEnter(product, variant)"
      (mouseleave)="onDetailLeave()"
      />
    </render-link>
  </ng-container>
  </div>
</div>
</idt-common-styles-render>
